import { createSelector } from '@reduxjs/toolkit';
const getState = (state) => state.products;
export const getProductsFetched = (state) => getState(state).productsFetched;
export const getProductsByIds = (state) => getState(state).byIds;
export const getSelectedProduct = (state) => getState(state).selectedProduct;
export const getAllProducts = createSelector(getProductsByIds, selectedProducts => {
    return Object.values(selectedProducts);
});
//# sourceMappingURL=selectors.js.map